var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.page.ID)?_c('div',{staticClass:"generic-page-content"},[(_vm.page.custom_fields.frontend_slug === 'how-it-works')?_c('how-it-works'):_c('default',{attrs:{"page-data":_vm.page}})],1):_c('four-oh-four')],1)}
var staticRenderFns = []

export { render, staticRenderFns }